<template>
    <div class="flex-1 min-w-0">
        <div class="mx-auto sm:px-6 my-4">
            <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">

                <div class="flex flex-wrap items-center border-b border-gray-200 px-3 pt-3">
                    <h2 class="font-semibold text-xl text-gray-800 leading-tight w-full md:w-auto md:mr-8 mb-2">
                        {{ __('Crea Spedizioni') }}
                    </h2>
                    <button type="button" @click="apriCrea"
                        class="px-4 py-2 -mb-px border-b-2 text-sm font-medium focus:outline-none"
                        :class="scheda === 'crea'
                            ? 'border-red-600 text-red-600'
                            : 'border-transparent text-gray-500 hover:text-gray-700'">
                        {{ __('Crea spedizione') }}
                    </button>
                    <button type="button" @click="apriElenco"
                        class="px-4 py-2 -mb-px border-b-2 text-sm font-medium focus:outline-none"
                        :class="scheda === 'elenco'
                            ? 'border-red-600 text-red-600'
                            : 'border-transparent text-gray-500 hover:text-gray-700'">
                        {{ __('Elenco spedizioni') }}
                    </button>
                    <!-- 08/10/2026: solo per i clienti con un profilo di importazione (admin) -->
                    <button v-if="importAttivo" type="button" @click="apriImporta"
                        class="px-4 py-2 -mb-px border-b-2 text-sm font-medium focus:outline-none"
                        :class="scheda === 'importa'
                            ? 'border-red-600 text-red-600'
                            : 'border-transparent text-gray-500 hover:text-gray-700'">
                        {{ __('Importa da file') }}
                    </button>
                    <!-- 13/10/2026: rubrica destinatari (vedere, correggere, cancellare) -->
                    <button type="button" @click="apriRubrica"
                        class="px-4 py-2 -mb-px border-b-2 text-sm font-medium focus:outline-none"
                        :class="scheda === 'rubrica'
                            ? 'border-red-600 text-red-600'
                            : 'border-transparent text-gray-500 hover:text-gray-700'">
                        {{ __('Rubrica') }}
                    </button>
                </div>

                <!-- 13/10/2026: avviso di admin (es. AS400 spento per manutenzione), su tutte le schede.
                     Si rilegge a ogni cambio di scheda; NON a tempo: una chiamata periodica
                     terrebbe viva la sessione all'infinito. -->
                <div v-if="avviso" class="mx-3 mt-3 px-4 py-3 rounded border border-yellow-400 bg-yellow-50 text-sm text-yellow-900 font-medium">
                    {{ avviso }}
                </div>

                <!-- 19/10/2026: spedizioni trasmesse oggi ma nessuna presa in AS400 per oggi al codice
                     del cliente (NFPRES). Si rilegge con l'avviso: cambio scheda e dopo una trasmissione. -->
                <div v-if="presaMancante" class="mx-3 mt-3 px-4 py-3 rounded border border-red-400 bg-red-50 text-sm text-red-800 font-medium">
                    {{ testoPresaMancante }}
                </div>

                <BollettazioneForm v-show="scheda === 'crea'" ref="form" :contratti="contratti" :formati="formati"
                    :giorni-lavorativi="giorniLavorativi" :giorni-ldv="giorniLdv"
                    @salvata="spedizioneSalvata" @setLoading="setLoading" @notify="notify">
                </BollettazioneForm>

                <BollettazioneElenco v-show="scheda === 'elenco'" ref="elenco" :formati="formati"
                    :attiva="scheda === 'elenco'" :ultima-attivita="ultimaAttivita"
                    @modifica="modificaBozza" @trasmesse="caricaAvviso" @setLoading="setLoading" @notify="notify">
                </BollettazioneElenco>

                <BollettazioneRubrica v-show="scheda === 'rubrica'" ref="rubrica"
                    @setLoading="setLoading" @notify="notify">
                </BollettazioneRubrica>

                <BollettazioneImporta v-if="importAttivo" v-show="scheda === 'importa'"
                    @elenco="apriElenco" @setLoading="setLoading" @notify="notify">
                </BollettazioneImporta>

            </div>
        </div>
    </div>
</template>

<script>
import BollettazioneForm from './BollettazioneForm.vue';
import BollettazioneElenco from './BollettazioneElenco.vue';
import BollettazioneImporta from './BollettazioneImporta.vue';
import BollettazioneRubrica from './BollettazioneRubrica.vue';

/**
 * Pagina "Crea Spedizioni" (nel codice e nel database resta bollettazione: si e'
 * cambiata solo la scritta che vede il cliente, il 29/09/2026).
 * Una voce di menu con due sottovoci, due schede.
 * Contratti e formati si caricano una volta sola qui e si passano alle due schede:
 * sono dati che non cambiano durante la sessione.
 *
 * NB: le schede usano v-show e non v-if, cosi' il modulo mezzo compilato non si
 * perde quando il cliente va a guardare l'elenco e torna indietro.
 */
export default {
    components: {
        BollettazioneForm,
        BollettazioneElenco,
        BollettazioneImporta,
        BollettazioneRubrica
    },
    data() {
        return {
            scheda: 'crea',
            // percorso <-> scheda in un posto solo: se un domani si aggiunge una
            // scheda si tocca questa riga e nient'altro.
            percorsi: { crea: '/bollettazione', elenco: '/bollettazione/elenco' },
            contratti: [],
            formati: [],
            giorniLavorativi: [],
            giorniLdv: [],
            timerSessione: null,
            ultimaAttivita: Date.now(),
            importAttivo: false,
            avviso: null,
            presaMancante: 0
        }
    },
    computed: {
        testoPresaMancante() {
            const n = this.presaMancante;
            return this.__('Oggi avete trasmesso') + ' ' + n + ' '
                + (n === 1 ? this.__('spedizione') : this.__('spedizioni'))
                + ', ' + this.__('ma non risulta ancora una richiesta di ritiro presso il vostro magazzino.') + ' '
                + this.__('Se non l\'avete già fatto, prenotate il ritiro.') + ' '
                + this.__('Se lo avete appena prenotato, questo avviso sparirà entro mezz\'ora.');
        }
    },
    watch: {
        // Il menu in alto cambia l'indirizzo mentre la pagina e' gia' aperta: la
        // scheda deve seguirlo. Qui NON si tocca l'indirizzo, altrimenti si rimbalza
        // con sincronizzaUrl().
        '$route.path'(nuovo) {
            const scheda = this.schedaDelPercorso(nuovo);
            if (this.scheda !== scheda) {
                this.scheda = scheda;
                if (scheda === 'elenco' && this.$refs.elenco) {
                    this.$refs.elenco.carica();
                }
            }
        }
    },
    async created() {
        this.scheda = this.schedaDelPercorso(this.$route.path);
        this.avviaRinnovoSessione();
        this.caricaAvviso();
        await this.caricaDatiFissi();
    },
    mounted() {
        // Qui e non in created(): $refs.elenco esiste solo a componente montato.
        // Serve a chi arriva direttamente sull'elenco (dal menu, dai preferiti o con
        // un F5): la lista va caricata subito.
        if (this.scheda === 'elenco' && this.$refs.elenco) {
            this.$refs.elenco.carica();
        }
    },
    beforeDestroy() {
        this.fermaRinnovoSessione();
    },
    methods: {
        setLoading(flag) {
            this.$emit('setLoading', flag);
        },
        notify(status, message, detail) {
            this.$emit('notify', status, message, detail);
        },

        async caricaDatiFissi() {
            await this.storeLogTime(async () => {
                const uri = this.$store.getters.uri;
                const contratti = await this.handleCallback(
                    () => this.axios.post(uri + '/bollettazione/contratti', {}), false, true, true);
                const formati = await this.handleCallback(
                    () => this.axios.post(uri + '/bollettazione/formati', {}), false, true, false);
                const giorni = await this.handleCallback(
                    () => this.axios.post(uri + '/bollettazione/giorni-lavorativi', {}), false, true, false);
                // 22/10/2026: giorni ammessi per la data LDV (oggi o il lavorativo dopo)
                const giorniLdv = await this.handleCallback(
                    () => this.axios.post(uri + '/bollettazione/giorni-ldv', {}), false, true, false);

                // scheda "Importa da file" solo se in admin il cliente ha un profilo;
                // se la chiamata non risponde la scheda semplicemente non compare
                const info = await this.handleCallback(
                    () => this.axios.post(uri + '/bollettazione/import-info', {}), false, false, false);
                const vi = this.estrai(info);
                this.importAttivo = !!(vi && vi.profilo);

                this.contratti = this.estrai(contratti);
                this.formati = this.estrai(formati);
                this.giorniLavorativi = this.estrai(giorni);
                this.giorniLdv = this.estrai(giorniLdv);
                return [contratti, formati, giorni];
            });
        },

        // ------------------------------------------------- sessione viva ---
        //
        // Il token JWT dura 60 minuti. Un cliente che apre il modulo, va a cercare i
        // dati della spedizione e torna dopo un'ora si vedeva buttare sul login con
        // tutto quello che aveva scritto perso. Finche' questa pagina e' aperta ED
        // E' STATO FATTO QUALCOSA di recente, il token si rinnova da solo.
        //
        // Il controllo sull'attivita' c'e' apposta: una scheda lasciata aperta tutta
        // la notte NON deve tenere viva la sessione per conto suo. Se per mezz'ora
        // nessuno tocca niente, il rinnovo si ferma e la sessione scade come prima.
        segnaAttivita() {
            this.ultimaAttivita = Date.now();
        },
        avviaRinnovoSessione() {
            ['mousedown', 'keydown', 'touchstart'].forEach(
                e => window.addEventListener(e, this.segnaAttivita, { passive: true }));
            // ogni 15 minuti: quattro occasioni di rinnovo dentro l'ora di durata del
            // token, quindi anche saltandone qualcuna per un problema di rete si fa in tempo
            this.timerSessione = setInterval(this.rinnovaSessione, 15 * 60 * 1000);
        },
        fermaRinnovoSessione() {
            ['mousedown', 'keydown', 'touchstart'].forEach(
                e => window.removeEventListener(e, this.segnaAttivita));
            if (this.timerSessione) {
                clearInterval(this.timerSessione);
                this.timerSessione = null;
            }
        },
        async rinnovaSessione() {
            if (Date.now() - this.ultimaAttivita > 30 * 60 * 1000) return;

            // store.dispatch('refresh') ora controlla il token prima di salvarlo e
            // restituisce false se il rinnovo non e' riuscito: il controllo sta in un
            // posto solo, qui non si ripete.
            // Se non riesce non si fa niente di rumoroso: il rinnovo e' una comodita'.
            // Alla prima chiamata vera scatta il 401, e da li' si riprova il rinnovo e
            // poi si va al login con il messaggio.
            const fatto = await this.$store.dispatch('refresh');
            if (!fatto) {
                console.log('rinnovo sessione non riuscito');
            }
        },

        /** Le risposte del tracking a volte hanno i dati in 'value', a volte no. */
        /** Avviso di admin (13/10/2026) e presa mancante (19/10/2026): se la chiamata non
         *  risponde, nessun avviso e nessun errore. */
        async caricaAvviso() {
            try {
                const res = await this.handleCallback(
                    () => this.axios.post(this.$store.getters.uri + '/bollettazione/avviso', {}), false, false, false);
                const v = res && res.value ? res.value : res;
                this.avviso = v && v.testo ? v.testo : null;
                // 19/10/2026: numero di spedizioni trasmesse oggi senza presa (0 = niente fascia)
                this.presaMancante = v && v.presa_mancante ? Number(v.presa_mancante) : 0;
            } catch (e) {
                this.avviso = null;
                this.presaMancante = 0;
            }
        },

        estrai(res) {
            if (!res) return [];
            return res.value ? res.value : res;
        },

        schedaDelPercorso(percorso) {
            return percorso === this.percorsi.elenco ? 'elenco' : 'crea';
        },

        /** Allinea l'indirizzo alla scheda aperta, senza ricaricare niente.
         *  Il catch() c'e' perche' vue-router considera un errore la navigazione
         *  verso l'indirizzo in cui si e' gia'. */
        sincronizzaUrl() {
            const percorso = this.percorsi[this.scheda];
            if (this.$route.path !== percorso) {
                this.$router.push(percorso).catch(() => {});
            }
        },

        apriCrea() {
            this.scheda = 'crea';
            this.sincronizzaUrl();
            this.caricaAvviso();
        },

        // nessun indirizzo proprio: la scheda si apre solo da qui, e con un F5 si torna
        // su "Crea spedizione" (una voce di menu servirebbe a tutti i clienti, non a pochi)
        // come Importa: niente indirizzo proprio, con un F5 si torna su "Crea spedizione"
        apriRubrica() {
            this.scheda = 'rubrica';
            this.caricaAvviso();
            this.$refs.rubrica.carica();
        },

        apriImporta() {
            this.scheda = 'importa';
            this.caricaAvviso();
        },

        apriElenco() {
            this.scheda = 'elenco';
            this.sincronizzaUrl();
            this.caricaAvviso();
            this.$refs.elenco.carica();
        },

        spedizioneSalvata() {
            this.apriElenco();
        },

        modificaBozza(richiesta) {
            this.scheda = 'crea';
            this.sincronizzaUrl();
            this.$refs.form.caricaBozza(richiesta);
        }
    }
}
</script>
